module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/prepared-checkout@2x-02704382128fff9bb3d5f041be01c457.jpg";